'use strict';

require('./appIncludes.js');
require('../admin/widgetIncludes.js');
require('../admin/account/widgetIncludes.js');
require('../admin/devtools/widgetIncludes.js');
require('../accountSettings/widgetIncludes.js');
require('../analyze/widgetIncludes.js');
require('../alerts/widgetIncludes.js');
require('../adsInsights/widgetIncludes.js');
require('../socialPosts/widgetIncludes.js');
require('../overview/widgetIncludes.js');
require('../reports/widgetIncludes.js');
require('../discovery/widgetIncludes.js');
require('../insights/widgetIncludes.js');
require('../companies/widgetIncludes.js');
require('../companyProfile/widgetIncludes.js');
require('../socialChannelMatrix/widgetIncludes.js');
require('../favorites/widgetIncludes.js');
require('../socialPosts/app.js');
require('../socialPosts/utils.js');
require('../socialPosts/collections/socialPosts.js');
require('../socialPosts/data/socialPosts.js');
require('../socialPosts/views/search.js');
require('../socialPosts/views/post.js');
require('../socialPosts/views/searchFilterCell.js');
require('../socialPosts/views/historyLimit.js');
require('../socialPosts/widgets/posts.js');
require('./data/ReactBridgeMappings.js');
require('./bootstrap.js');
